import { render, staticRenderFns } from "./IncludedRevenueRoyalty.vue?vue&type=template&id=ceaede90"
import script from "./IncludedRevenueRoyalty.vue?vue&type=script&lang=js"
export * from "./IncludedRevenueRoyalty.vue?vue&type=script&lang=js"
import style0 from "./IncludedRevenueRoyalty.vue?vue&type=style&index=0&id=ceaede90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports